export default __webpack_public_path__ + "static/media/downArrowHover.9e7e7d9c.png";